export default "/images/vendor/@coreui/icons/svg/flag/cif-mr.svg?ee350e5ef685aa0e22f6145ddd99ce39";